<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/"></ion-back-button>
    </ion-buttons>
    <ion-title
      [innerHTML]="(displayAddress$ | async) || 'General Information'"
    ></ion-title>
  </ion-toolbar>
</ion-header>
<!-- General Information Content -->
<ion-content class="GeneralInformation">
  <ion-card class="GeneralInformation__TopCard">
    <ion-card-content>
      <div class="GeneralInformation__StatusRow">
        <ion-chip color="primary" class="GeneralInformation__Status">
          <ion-label>{{ propertyStatus | titlecase }}</ion-label>
        </ion-chip>
        <span
          class="GeneralInformation__StatusDate"
          [innerHTML]="propertyStatusDate"
        ></span>
        @if (propertyStatusDate) {
          <ion-button
            fill="clear"
            color="primary"
            class="GeneralInformation__EditButton"
            (click)="workflowProgress(true)"
          >
            <ion-icon name="create"></ion-icon>
          </ion-button>
        }
      </div>

      <div class="container">
        <div class="row">
          <div class="col-md-7 col-12 mb-2">
            <smartflip-property-image
              class="GeneralInformation__Image"
              [imgUrl]="imgUrl"
              [editable]="true"
              [initialSlideIndex]="selectedPhotoIndex"
              imgClass="GeneralInformation__ImageDeep"
              (thumbnailChanged)="updateThumbnailImage($event)"
              [propertyId]="propertyId"
              [propertyPhotos]="images"
            ></smartflip-property-image>
          </div>
          <div
            class="GeneralInformation__ButtonWrapper col-12 col-md-5 flex-wrap flex"
          >
            @if (loanFeatureEnabled) {
              <ion-button
                class="GeneralInformation__Button"
                fill="solid"
                color="primary"
                (click)="viewLoanApplication()"
              >
                Fund this Flip
                <ion-icon name="cash" slot="end"></ion-icon>
              </ion-button>
            }
            @if (propertyStatus !== 'Sold') {
              <ion-button
                class="GeneralInformation__Button"
                color="primary"
                data-test-id="workflowProgressButton"
                id="workflow-progress"
                fill="solid"
                (click)="workflowProgress()"
                [disabled]="pullingAPIDataNotAllowed()"
              >
                <span [innerHTML]="workflowButtonText"></span>&nbsp;
                <ion-icon name="card" slot="end"></ion-icon>
                @if (pullingAPIDataNotAllowed()) {
                  <span
                    class="GeneralInformation__Warning"
                    [innerHTML]="'Full address is required to continue.'"
                  ></span>
                }
              </ion-button>
            }
            <ion-button
              class="GeneralInformation__Button"
              fill="solid"
              (click)="refreshGeneralData()"
              [disabled]="!isDataRefreshAllowed()"
            >
              <span [innerHTML]="'Retrieve Public Data'"></span>&nbsp;
              <ion-icon name="refresh" slot="end"></ion-icon>
              @if (pullingAPIDataNotAllowed()) {
                <span class="GeneralInformation__Warning"
                  >Full address is required to continue.</span
                >
              }
            </ion-button>
            @if (!isDataRefreshAllowed() && !pullingAPIDataNotAllowed()) {
              <span class="GeneralInformation__Warning--Subscribe"
                >Upgrade to the <a href="/home/subscribe">Pro Tier</a> now for
                additional refreshes!</span
              >
            }
            <ion-button
              class="GeneralInformation__Button"
              color="danger"
              data-test-id="deletePropertyButton"
              id="delete-property"
              fill="solid"
              (click)="deleteProperty()"
            >
              Delete this Property
              <ion-icon name="trash" slot="end"></ion-icon>
            </ion-button>
          </div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <main id="general-information-cards">
    <!-- General Card -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>General Property Info</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        @if (!loading) {
          <form
            class="GeneralInformation__Form"
            [formGroup]="generalForm"
            (submit)="onSubmit($event)"
          >
            @for (field of fieldList; track field; let i = $index) {
              <ng-container
                dynamicField
                [field]="field"
                [group]="generalForm"
                [className]="field.class"
              >
                @if (i === 5) {
                  <div class="break"></div>
                }
              </ng-container>
            }
          </form>
        }
      </ion-card-content>
    </ion-card>

    <!-- Owner Info -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Owner Information</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        @if (!loading) {
          <form class="GeneralInformation__Form" [formGroup]="ownerForm">
            @for (field of ownerFieldList; track field; let i = $index) {
              <ng-container dynamicField [field]="field" [group]="ownerForm">
              </ng-container>
            }
          </form>
        }
      </ion-card-content>
    </ion-card>

    <!-- Mortgage Info -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Mortgage Information</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        @if (!loading) {
          <form class="GeneralInformation__Form" [formGroup]="mortgageForm">
            @for (field of mortgageFieldList; track field; let i = $index) {
              <ng-container dynamicField [field]="field" [group]="mortgageForm">
              </ng-container>
            }
          </form>
        }
      </ion-card-content>
    </ion-card>
  </main>
</ion-content>
